<template>
  <span @click="handleClick">
    <icon-svg :name="iconName" />
  </span>
</template>

<script>
import { Message } from 'element-ui';
import screenfull from 'screenfull/dist/screenfull';
import IconSvg from '@/components/icon/icon-svg.vue';

export default {
  name: 'Fullscreen',
  props: {
    // unusable message
    unusableMsg: {
      type: String,
      default: 'you browser can not work',
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: {
    IconSvg,
  },
  data() {
    return {
      isFullscreen: false,

    };
  },
  created() {
    this.handleChangeFullscreen();
  },
  computed: {
    iconName: {
      get() {
        return this.isFullscreen ? 'exit-fullscreen' : 'fullscreen';
      },
    },
  },
  methods: {
    // 监听是否全屏，改变icon样式
    handleChangeFullscreen() {
      if (screenfull.enabled) {
        screenfull.on('change', () => {
          this.isFullscreen = screenfull.isFullscreen;
        });
      }
    },
    handleClick() {
      if (!screenfull.enabled) {
        Message.warning(this.unusableMsg);
      } else {
        // 指定内容全屏
        const element = document.getElementById(this.id);
        screenfull.toggle(element);
      }
    },
  },
};
</script>
